exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-toolbar__title[data-v-ce998f06] {\n  text-transform: uppercase;\n}", ""]);

// exports
